export const LIST = 'list';
export const GRID = 'grid';
export const VIEW_TYPES = [LIST, GRID];
export const SELECT_VIEW_OPTIONS = [
  { value: LIST, label: 'List' },
  { value: GRID, label: 'Grid' }
];
